export default function masks(){
    $(document).ready(function(){
        $("#cnpj").mask("00.000.000/0000-00", {reverse: true,});
        $("#phone").mask("(00) 00000-0000");
    });
}